<template>
  <editor :id="id" default-tab="instance" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Instance from './editor/Instance'
import Stats from './editor/Stats'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Instance",      name: "instance",      component: Instance},
        {title: "Stats",         name: "stats",         component: Stats}
      ]
    }
  }
}
</script>
